import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sun, Moon, MonitorSmartphone, Check } from 'lucide-react';

const OPTIONS = [
  { id: 'light',  label: 'Light',          sub: 'Bright, classic look',            Icon: Sun },
  { id: 'dark',   label: 'Dark',           sub: 'Easy on the eyes at night',       Icon: Moon },
  { id: 'system', label: 'System default', sub: 'Follows your device setting',     Icon: MonitorSmartphone },
];

/**
 * ThemePicker — Appearance control shared by Talent / Agency / Client
 * settings hubs. Renders three selectable cards on the dark hub canvas.
 */
export const ThemePicker = () => {
  const { preference, resolved, setPreference } = useTheme();

  return (
    <div data-testid="theme-picker">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {OPTIONS.map(({ id, label, sub, Icon }) => {
          const active = preference === id;
          return (
            <button
              key={id}
              onClick={() => setPreference(id)}
              data-testid={`theme-option-${id}`}
              className={`text-left rounded-xl border p-4 transition-all duration-150 ${
                active
                  ? 'border-cyan-400/70 bg-cyan-400/10 ring-1 ring-cyan-400/40'
                  : 'border-white/10 bg-white/[0.04] hover:border-white/25 hover:bg-white/[0.07]'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${
                  active ? 'bg-cyan-400/20 text-cyan-300' : 'bg-white/10 text-slate-300'
                }`}>
                  <Icon className="w-4.5 h-4.5" size={18} />
                </span>
                {active && <Check className="w-4 h-4 text-cyan-300" data-testid={`theme-active-${id}`} />}
              </div>
              <p className={`mt-3 text-sm font-semibold ${active ? 'text-cyan-100' : 'text-slate-100'}`}>{label}</p>
              <p className="text-xs text-slate-400 mt-0.5">{sub}</p>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-slate-500 mt-3" data-testid="theme-current-note">
        Currently showing the <span className="text-slate-300 font-medium">{resolved}</span> theme
        {preference === 'system' ? ' (from your device setting)' : ''}. Your choice is saved to your
        account and applies everywhere you sign in.
      </p>
    </div>
  );
};

export default ThemePicker;
